module.exports = __webpack_public_path__ + "img/paytable_icon.96160169.svg";